import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { Produto } from 'src/app/core/models/produto.model';
import { WeblabService } from 'src/app/core/services/weblab.service';

@Component({
  selector: 'app-novo-pedido-olho',
  templateUrl: './novo-pedido-olho.component.html',
  styleUrls: ['./novo-pedido-olho.component.scss']
})
export class NovoPedidoOlhoComponent implements OnChanges{

  @Input() titulo: string;
  @Input() olho: NovoPedidoOlho;
  @Input() olhoSelecionadoAmbos: any;
  @Input() codLoja: number | undefined;
  @Input() codCliente: number | undefined;
  produtosLentesFiltrado: Array<Produto> = [];

  constructor(private service: WeblabService) {}

  @Output() DNPLongeChange = new EventEmitter<boolean>();
  @Output() ProdutoChange = new EventEmitter<Produto>();
  @Output() QuantidadeChange = new EventEmitter<number>();
  maxlength: number = 5;

  quantidadeStr: string = '1,0';

  private autocompleteHandler: any = null;
  private hchangeProdutoEmit: any = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['olho']) {
      const q = this.olho?.olhoQuantidade ?? 1;
      this.quantidadeStr = q.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    }
  }

  onQuantidadeBlur(): void {
    const parsed = parseFloat((this.quantidadeStr || '1').replace(',', '.'));
    const snapped = Math.round((isNaN(parsed) || parsed < 0.5 ? 1 : parsed) * 2) / 2;
    this.olho.olhoQuantidade = snapped;
    const isHalf = snapped % 1 !== 0;
    this.quantidadeStr = snapped.toLocaleString('pt-BR', {
      minimumFractionDigits: isHalf ? 1 : 0,
      maximumFractionDigits: 1
    });
    this.QuantidadeChange.emit(snapped);
  }
  primaBasesHorizontal: any[] = [
    {
      id: 1,
      nome: 'Nasal'
    },
    {
      id: 2,
      nome: 'Temporal'
    },
    // {
    //   id: 3,
    //   nome: 'Inferior'
    // },
    // {
    //   id: 4,
    //   nome: 'Superior'
    // },
    // {
    //   id: 5,
    //   nome: 'Nasal Inferior'
    // },
    // {
    //   id: 6,
    //   nome: 'Nasal Superior'
    // },
    // {
    //   id: 7,
    //   nome: 'Temporal Inferior'
    // },
    // {
    //   id: 8,
    //   nome: 'Temporal Superior'
    // }
  ]

  primaBasesVertical: any[] = [
    // {
    //   id: 1,
    //   nome: 'Nasal'
    // },
    // {
    //   id: 2,
    //   nome: 'Temporal'
    // },
    {
      id: 3,
      nome: 'Inferior'
    },
    {
      id: 4,
      nome: 'Superior'
    },
    // {
    //   id: 5,
    //   nome: 'Nasal Inferior'
    // },
    // {
    //   id: 6,
    //   nome: 'Nasal Superior'
    // },
    // {
    //   id: 7,
    //   nome: 'Temporal Inferior'
    // },
    // {
    //   id: 8,
    //   nome: 'Temporal Superior'
    // }
  ]
  changeDNPLonge(event: Event) {
    this.DNPLongeChange.emit(true);
  }

  // changeAdicao(event: number) {
  //   // let adicao = this.olho.olhoAdicao
  //   let adicao = event;

  //   if (adicao) {
  //     let olhoLongeEsferico = this.olho.olhoLongeEsferico ?? 0;
  //     let olhoLongeDNP = this.olho.olhoLongeDNP ?? 0;

  //     this.olho.olhoPertoEsferico = olhoLongeEsferico + adicao;
  //     this.olho.olhoPertoCilindrico = this.olho.olhoLongeCilindrico;
  //     this.olho.olhoPertoEixo = this.olho.olhoLongeEixo;
  //     this.olho.olhoPertoDNP = olhoLongeDNP - 2.5;
  //   } else {
  //     this.olho.olhoPertoEsferico = this.olho.olhoLongeEsferico;
  //     this.olho.olhoPertoCilindrico = this.olho.olhoLongeCilindrico;
  //     this.olho.olhoPertoEixo = this.olho.olhoLongeEixo;
  //     this.olho.olhoPertoDNP = this.olho.olhoLongeDNP;
  //   }
  // }

  // changeEixoLonge($event: any) {
  //   console.log('eixo longe', $event, this.olho.olhoLongeEixo);
  // }

  blurLonge() {
    
    let adicao = this.olho.olhoAdicao 
    
    if (adicao) {
      let olhoLongeEsferico = this.olho.olhoLongeEsferico ?? 0;
      let olhoLongeDNP = this.olho.olhoLongeDNP ?? 0;

      this.olho.olhoPertoEsferico = Number(olhoLongeEsferico.toString().replace(',', '.')) + Number(adicao.toString().replace(',', '.'));
      this.olho.olhoPertoEsferico = this.formatarInputBlur(this.olho.olhoPertoEsferico);

      let cilindrico = this.olho.olhoLongeCilindrico ?? '';
      this.olho.olhoPertoCilindrico = this.formatarInputBlur(cilindrico);

      this.olho.olhoPertoEixo = this.formatarInputBlur(this.olho.olhoLongeEixo);
      this.olho.olhoPertoDNP = Number(olhoLongeDNP.toString().replace('.', '').replace(',', '.')) - 2.5;
      this.olho.olhoPertoDNP = this.formatarInputBlur(this.olho.olhoPertoDNP);
    }
    
    
    // else {
    //   this.olho.olhoPertoEsferico = this.olho.olhoLongeEsferico;
    //   this.olho.olhoPertoCilindrico = this.olho.olhoLongeCilindrico;
    //   this.olho.olhoPertoEixo = this.olho.olhoLongeEixo;
    //   this.olho.olhoPertoDNP = this.olho.olhoLongeDNP;
    // }
  }

  // parseNumber(value: string | undefined) {
  //   if (!value) value = '0';

  //   return Number(value.replace('.', '').replace(',', '.'));
  // }

  changeProdutoEmit($event: any) {
    const self = this;
    clearTimeout(this.hchangeProdutoEmit);
    this.hchangeProdutoEmit = setTimeout(() => {
      self.ProdutoChange.emit(self.olho.olhoLente);
    }, 1000);
  }
  
  async filterAutoComplete(event: AutoCompleteCompleteEvent) {
    if (!this.codLoja || !this.codCliente || event.query.length < 2) {
      this.produtosLentesFiltrado = [];
      return;
    }

    try {
      const resp: any = await new Promise((resolve, reject) =>
        this.service.produtosBusca(this.codLoja!, this.codCliente!, event.query).subscribe({ next: resolve, error: reject })
      );

      this.produtosLentesFiltrado = (resp?.Produtos || [])
        .filter((p: Produto) => p.especie?.toLowerCase() === 'lente')
        .map((p: Produto) => {
          const vlr_venda_tratado = p.vlr_fab > 0 ? p.vlr_fab : p.vlr_venda;
          const perc_desconto = p.desc_acresc_porcentagem === null ? 0 : p.desc_acresc_porcentagem;
          return {
            ...p,
            desc_acresc_porcentagem: perc_desconto,
            vlr_venda_tratado,
            vlr_liquido_produto: vlr_venda_tratado > 0 && perc_desconto > 0
              ? vlr_venda_tratado - (vlr_venda_tratado * perc_desconto / 100)
              : vlr_venda_tratado
          };
        });
    } catch {
      this.produtosLentesFiltrado = [];
    }
  }

  isOnlyNumbers(text: string): boolean {
    const regex = /^\d+$/;
    return regex.test(text);
  }

  eixoMinMax(el: any) {
    setTimeout(() => {
      if (el.value != '') {
        if (parseInt(el.target.value) < el.target.min) {
          el.target.value = el.target.min;
        }
        if (parseInt(el.target.value) > el.target.max) {     
          el.target.value = el.target.max;
        }
      }
      this.olho.olhoLongeEixo = el.target.value;
    }, 500);
  }  

  formatarInput(input: any, campo?: string): void {
    const raw: string = input.value;

    // Determina sinal a partir dos caracteres de sinal presentes no valor bruto
    const signOnly = raw.replace(/[^\d+\-]/g, '');
    const isNegative = signOnly.startsWith('-');
    const hasPositiveSign = !isNegative && signOnly.startsWith('+');

    // Extrai apenas dígitos (outros caracteres que não sejam + ou - são ignorados)
    const digitsOnly = raw.replace(/\D/g, '');

    if (digitsOnly === '') {
      // Apenas sinal digitado ou campo vazio — não insere nada automaticamente
      input.value = isNegative ? '-' : (hasPositiveSign ? '+' : '');
      this.receberValorConvertido(input.value, campo);
      return;
    }

    let number = parseFloat(digitsOnly) / 100;
    if (isNegative) number = -number;

    this.maxlength = (isNegative || hasPositiveSign) ? 6 : 5;

    if (campo === 'adicao') {
      const maxAllowed = 9.99;
      if (number > maxAllowed) number = maxAllowed;
      else if (number < -maxAllowed) number = -maxAllowed;
    }

    let formattedValue = number.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (hasPositiveSign) formattedValue = '+' + formattedValue;

    input.value = formattedValue;
    this.receberValorConvertido(formattedValue, campo);
  }

  receberValorConvertido(valor: any, campos?: string) {
    switch (campos) {
      case 'esfericoLonge':
        this.olho.olhoLongeEsferico = valor
        break;
      case 'dnpLonge':
        this.olho.olhoLongeDNP = valor
        break;
      case 'cilindricoLonge':
        this.olho.olhoLongeCilindrico = valor;
        break;
      case 'esfericoPerto':
        this.olho.olhoPertoEsferico = valor
        break;
      case 'dnpPerto':
        this.olho.olhoPertoDNP = valor
        break;
      case 'cilindricoPerto':
        this.olho.olhoPertoCilindrico = valor;
      break;
      case 'adicao':
        this.olho.olhoAdicao = valor;
        break;        
      case 'altura_pupila':
        this.olho.olhoAlturaPupila = valor;
        break;        
        case 'prisma_hor_valor':
          this.olho.olhoPrismaHorizontalValor = valor;
          break; 
        case 'prisma_vert_valor':
          this.olho.olhoPrismaVerticalValor = valor;
          break;
      default:
        break;
    }
  }

  converterValor(decimalStr: string) {
    const inputNumericValue = decimalStr.replace(/[^\d.-]/g, '');
    const isNegative = inputNumericValue.startsWith('-');

    let number = parseFloat(inputNumericValue) / 100;

    let formattedValue = number.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (formattedValue === 'NaN') {
        formattedValue = '-';
    }
    let valorFormatado = formattedValue;
      
    return valorFormatado;
  }

  formatarInputBlur(input: any) {

    const formatoNovo = input.toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2});

    return formatoNovo

  }

}

export interface NovoPedidoOlho {
  olhoLente?: Produto | undefined;
  olhoQuantidade?: number | undefined;

  olhoLongeEsferico?: number | undefined;
  olhoLongeCilindrico?: number | undefined;
  olhoLongeEixo?: number | undefined;
  olhoLongeDNP?: number | undefined;

  olhoAdicao?: number | undefined;

  olhoPertoEsferico?: number | undefined;
  olhoPertoCilindrico?: number | undefined;
  olhoPertoEixo?: number | undefined;
  olhoPertoDNP?: number | undefined;

  olhoAlturaPupila?: number | undefined;
  olhoPrismaHorizontalValor?: number | undefined;
  olhoPrismaVerticalValor?: number | undefined;
  olhoPrismaHorizontalBase?: any | undefined;
  olhoPrismaVerticalBase?: any | undefined;

}
